import { intl } from '@/intl'
import { getMapInfo } from '@/map'
import { colorPalette } from '@/server-data'
import { locationUtils } from '@/utils'

export const emptyDepotId = ''

export function createEmptyDepot(): uui.domain.client.rm.Depot {
  const { center } = getMapInfo()

  const depotLocation = locationUtils.createEmptyLocation({
    latLng: center,
  })

  if (!depotLocation && process.env.NODE_ENV === 'development') {
    throw new Error('Impossible to initialize a default location for the depot')
  }

  return {
    id: emptyDepotId,
    name: intl.translate({ id: 'setup.depots.newDepot' }),
    location: depotLocation,
    color: colorPalette[0],
    setupCost: 0,
    setupTimeSec: 0,
    orderSteps: {},
  }
}
